export default __webpack_public_path__ + "locales/si/UploadPanel.json?hash=85b1255f4be4da2e30d50d02e66b3703";